import {useEffect, useRef, useState} from 'react';
import noAttend from '../../assets/icons/noAttend.svg';
import ModalContainer from '../modalContainer/index.jsx';
import NoAttendanceModal from '../noAttendanceModal';

import './style.scss';
import {toast} from "react-toastify";

function UserAttendanceCard({data}) {
    // STATES //
    const [attended, setAttended] = useState(null);
    const [OpenModalAdd, setOpenModalAdd] = useState(false);
    const [imageUrl, setImageUrl] = useState('');
    const inputRef = useRef(null);

    const baseURL = process.env.REACT_APP_API_URL + process.env.REACT_APP_API_URI;

    const info = {
        title: 'Motivo inasistencia',
        argumentValue: 'Argumento',
        observations: 'Observaciones del dinamizador'
    };

    function updateValues(value) {
        if (!data.savedInMeeting) {
            setAttended(value);
            data.attended = value;
            if (value === false) {
                setOpenModalAdd(true);
            }
        }
    }

    function captureImage(target) {
        if (!data.savedInMeeting) {
            if (target.files) {
                if (target.files.length > 0) {
                    const file = target.files[0];
                    const newUrl = URL.createObjectURL(file);

                    const reader = new FileReader();
                    reader.readAsDataURL(file);
                    reader.onload = () => {

                        const image = new Image();
                        image.src = reader.result;

                        image.onload = () => {
                            const canvas = document.createElement('canvas');
                            const maxWidth = 800; // Set your desired maximum width here
                            const maxHeight = 600; // Set your desired maximum height here
                            let width = image.width;
                            let height = image.height;

                            if (width > height) {
                                if (width > maxWidth) {
                                    height *= maxWidth / width;
                                    width = maxWidth;
                                }
                            } else {
                                if (height > maxHeight) {
                                    width *= maxHeight / height;
                                    height = maxHeight;
                                }
                            }

                            canvas.width = width;
                            canvas.height = height;

                            const context = canvas.getContext('2d');
                            context.drawImage(image, 0, 0, width, height);

                            const resizedImageBase64 = canvas.toDataURL('image/jpeg');
                            // Perform further processing with the imageBase64 data if needed
                            data.base64 = resizedImageBase64;
                        };
                    }
                    data.image = newUrl;
                    data.attended = true;
                    data.argument = null;
                    data.notes = null;
                    setImageUrl(newUrl);
                }
            }
        }
    }

    function handleImageClick() {
        if (!data.savedInMeeting) {
            updateValues(true);
            // Trigger the input click event
            if (inputRef) {
                inputRef.current.click();
            }
        }else{
            toast('No puedes modificar la asistencia almacenada', {
                type: 'info'
            });
        }
    }

    function updateAttendanceInfo(info) {
        data.attended = false;
        data.argument = info.argument;
        data.notes = info.notes;
        data.image = null;
        data.base64 = null;
    }

    useEffect(() => {
        if (data.attended !== undefined && data.attended !== null) {
            setAttended(data.attended);
            if (data.attended === true) {
                setImageUrl(`${baseURL}/image?imageId=${data.imageId}&thumbnail=${(!!data.thumbnail)}`)
            }
        }
    }, data);
    return (
        <>
            {OpenModalAdd && (
                <ModalContainer>
                    <NoAttendanceModal info={info} setOpenModalAdd={setOpenModalAdd}
                                       updateAttendanceInfo={updateAttendanceInfo}/>
                </ModalContainer>
            )}
            <div className='user-container'>
                <h2 className='name'>{data?.full_name}</h2>
                <div className='buttons-container'>
                    <button
                        onClick={() => handleImageClick(false)}
                        className={`attended 
                        ${attended === null || attended === undefined || attended === false ?
                            'attended--false' : ''
                        }`}>
                        <svg
                            xmlns='http://www.w3.org/2000/svg'
                            width='21'
                            className='svg'
                            height='16.747'
                            viewBox='0 0 21 16.747'>
                            <path
                                id='how_to_reg_FILL0_wght400_GRAD0_opsz48'
                                d='M4,25.228V22.76a3.144,3.144,0,0,1,.446-1.641,2.836,2.836,0,0,1,1.339-1.142A19.623,19.623,0,0,1,9.25,18.77,13.822,13.822,0,0,1,12.4,18.4a15.11,15.11,0,0,1,1.614.092,11.731,11.731,0,0,1,1.746.328l-1.286,1.286q-.525-.052-1.037-.092T12.4,19.977a12.854,12.854,0,0,0-2.769.276A18.217,18.217,0,0,0,6.415,21.4a1.314,1.314,0,0,0-.643.6,1.7,1.7,0,0,0-.2.761v.893h8.374l1.575,1.575Zm14.306.42-3.7-3.7,1.1-1.1,2.6,2.6L23.9,17.851l1.1,1.1ZM12.4,16.775a3.776,3.776,0,0,1-3.937-3.937A3.776,3.776,0,0,1,12.4,8.9a3.776,3.776,0,0,1,3.938,3.937A3.776,3.776,0,0,1,12.4,16.775ZM13.949,23.653ZM12.4,15.2a2.289,2.289,0,0,0,2.362-2.362A2.289,2.289,0,0,0,12.4,10.475a2.289,2.289,0,0,0-2.363,2.363A2.289,2.289,0,0,0,12.4,15.2ZM12.4,12.837Z'
                                transform='translate(-4 -8.9)'
                                fill='#FFFFFF'
                            />
                        </svg>
                    </button>

                    <input accept="image/*"
                           type="file"
                           ref={inputRef}
                           capture="environment"
                           onChange={(e) => captureImage(e.target)}
                           style={{display: 'none'}}
                    />
                    <button
                        onClick={() => {
                            updateValues(false);
                        }}
                        className={`
                        ${attended === null || attended === undefined || attended === true ?
                            'not-attend' : 'not-attend not-attend--false'
                        }`}>
                        <img src={noAttend} alt=''/>
                    </button>
                    {attended === null || attended === undefined ? (
                        <p></p>
                    ) : (
                        attended === true ? (
                            <>
                                <p className='attended-text'>Asistió</p>
                                <img
                                    className='photo'
                                    src={imageUrl}
                                    alt={`Image`}
                                    onClick={() => handleImageClick()}
                                />
                            </>
                        ) : (
                            <p className='no-attend'>No asistió</p>
                        )
                    )}
                </div>
            </div>
        </>
    );
}

export default UserAttendanceCard;
